import { catalystInsights, DetailedCatalystInsight } from '@api';
import { wretchRequest } from '@terminal/utils/api-fetch/apiFetch';

export const getCatalystInsightDetails = (insightId: string) => {
  const { path, schema } = catalystInsights.getCatalystInsight;
  return wretchRequest<DetailedCatalystInsight>(path(insightId), {
    schema,
  });
};
